import VrrFloatInput from './VrrFloatInput';

export default VrrFloatInput;
